module.exports = __webpack_public_path__ + "static/media/microsoftExcel.c59164de.svg";